import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Top Centered Brand Tagline Text */}
        <div className={styles.brandHeadingWrap}>
          <span className={styles.brandEyebrow}>FAITH FELLOWSHIP CHURCH</span>
          <h3 className={styles.brandHeading}>“To know Jesus and make Jesus known”</h3>
        </div>

        {/* Centered Navigation Row */}
        <nav className={styles.navRow} aria-label="Footer Navigation">
          <NavLink to="/leadership" className={styles.navLink}>Leadership</NavLink>
          <NavLink to="/missionandvision" className={styles.navLink}>Mission &amp; Vision</NavLink>
          <NavLink to="/bylaws" className={styles.navLink}>Bylaws</NavLink>
          <NavLink to="/blogs" className={styles.navLink}>Blog</NavLink>
          <NavLink to="/eventscalendar" className={styles.navLink}>Schedule</NavLink>
          <NavLink to="/women" className={styles.navLink}>Ministries</NavLink>
          <NavLink to="/contact" className={styles.navLink}>Contact</NavLink>
        </nav>

        {/* Contact Info */}
        <div className={styles.contactRow}>
          <span className={styles.contactLabel}>Contact Info</span>
          <div className={styles.phoneList}>
            <a href="mailto:faithfellowship.ora@gmail.com" className={styles.emailLink}>
              faithfellowship.ora@gmail.com
            </a>
            <span className={styles.phoneDivider}>•</span>
            <a href="tel:+96892537021" className={styles.phoneLink}>+968 9253 7021</a>
            <span className={styles.phoneDivider}>•</span>
            <a href="tel:+96893970814" className={styles.phoneLink}>+968 9397 0814</a>
            <span className={styles.phoneDivider}>•</span>
            <a href="tel:+96899011662" className={styles.phoneLink}>+968 9901 1662</a>
          </div>
        </div>

        {/* Social Media Icons (Static / Disabled) */}
        <div className={styles.socialRow}>
          <span className={styles.socialBtnDisabled} role="img" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={styles.socialIcon}>
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </span>
          <span className={styles.socialBtnDisabled} role="img" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="currentColor" className={styles.socialIcon}>
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
          </span>
          <span className={styles.socialBtnDisabled} role="img" aria-label="YouTube">
            <svg viewBox="0 0 24 24" fill="currentColor" className={styles.socialIcon}>
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </span>
        </div>

        {/* Location & Copyright Subtext */}
        <div className={styles.subInfo}>
          <p className={styles.subText}>
            Old Main Hall, PCO Campus, Ruwi, Sultanate of Oman &nbsp;•&nbsp; © 2026 Faith Fellowship
          </p>
        </div>
      </div>

      {/* Giant Bottom Billboard Band (Subtle Bottom Bleed & Soft Opacity) */}
      <div className={styles.giantBand}>
        <svg
          viewBox="0 0 1600 165"
          className={styles.giantSvg}
          aria-label="faith fellowship"
        >
          <defs>
            <linearGradient id="footerCharcoalGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#374151" stopOpacity="0.38" />
              <stop offset="50%" stopColor="#6b7280" stopOpacity="0.18" />
              <stop offset="100%" stopColor="#9ca3af" stopOpacity="0.03" />
            </linearGradient>
          </defs>
          <text
            x="0"
            y="170"
            textLength="1600"
            lengthAdjust="spacingAndGlyphs"
            fill="url(#footerCharcoalGrad)"
            className={styles.svgText}
          >
            faith fellowship
          </text>
        </svg>
      </div>
    </footer>
  );
}